import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Phone, { parsePhoneNumber } from 'react-phone-number-input';

// Components
import Password from '../Common/Password';

const EditAdmin = observer(class EditAdmin extends React.Component {
  constructor() {
    super();
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    SessionStore.getTimezones();
    SessionStore.getCurrencies();

    if(getURLSegment(this, 2) === 'edit') {
      const userSid = getURLSegment(this, 3);
      this.getAdminUser(userSid);
    }
  }

  getAdminUser(userSid) {
    this.props.store.EnrollmentStore.getAdminUser(userSid);
  }

  handleInput(e, name) {
    let data = null;
    let value = null;

    if(name === 'homePhone' || name === 'mobilePhone') {
      value = e;
    } else {
      value = e.target.value;
    }

    // Make sure boolean values are boolean
    if(value === 'true') {
      value = true;
    }
    if(value === 'false') {
      value = false;
    }

    data = {
      [name]: value
    };

    this.props.store.EnrollmentStore.updateAdminData(data);
  }

  handleSubmit() {
    const userSid = getURLSegment(this, 3);

    if(userSid) {
      this.props.store.EnrollmentStore.updateAdmin(userSid, this.complete);
    } else {
      this.props.store.EnrollmentStore.createAdmin(this.complete);
    }
  }

  complete() {
    closeDrawer(null, this.props.parent, getURLSegment(this, 1));
    this.props.store.SessionStore.showToaster(this.props.translation.admin_saved, 'success');
  }

  render() {
    const { translation } = this.props;
    const { EnrollmentStore, SessionStore } = this.props.store;
    const { admin } = EnrollmentStore;
    const userSid = getURLSegment(this, 3);

    if(!SessionStore.loading) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              {userSid &&
                <h1 className="drawer__title">{translation.edit_heading}</h1>
              }

              {!userSid &&
                <h1 className="drawer__title">{translation.add_heading}</h1>
              }
            </div>
          </header>

          <div className="wrap">
            <form className="panel panel--medium" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <fieldset>
                <ul className="fields">
                  <li className="field--half">
                    <label className="lbl-required" htmlFor="admin-fname">{translation.fname.label}</label>
                    <input
                      type="text"
                      id="admin-fname"
                      ref={(input) => {this.firstName = input}}
                      onChange={(e) => {this.handleInput(e, 'firstName')}}
                      defaultValue={admin.firstName}
                      required
                      aria-required="true"
                    />
                  </li>
                  <li className="field--half">
                    <label className="lbl-required" htmlFor="admin-lname">{translation.lname.label}</label>
                    <input
                      type="text"
                      id="admin-lname"
                      ref={(input) => {this.lastName = input}}
                      onChange={(e) => {this.handleInput(e, 'lastName')}}
                      defaultValue={admin.lastName}
                      required
                      aria-required="true"
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="admin-email">{translation.email.label}</label>
                    <input
                      type="email"
                      id="admin-email"
                      ref={(input) => {this.email = input}}
                      onChange={(e) => {this.handleInput(e, 'email')}}
                      defaultValue={admin.email}
                      required
                      aria-required="true"
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="admin-username">{translation.username.label}</label>
                    <input
                      type="text"
                      id="admin-username"
                      ref={(input) => {this.username = input}}
                      onChange={(e) => {this.handleInput(e, 'username')}}
                      defaultValue={admin.username}
                      required
                      aria-required="true"
                    />
                  </li>
                  {!userSid &&
                    <li>
                      <label className="lbl-required" htmlFor="admin-password">{translation.password.label}</label>
                      <Password
                        id="admin-password"
                        changeFunction={this.handleInput}
                        {...this.props}
                      />
                    </li>
                  }
                  <li>
                    <label className="lbl-optional" htmlFor="admin-home">{translation.home_phone.label}</label>
                    <Phone
                      id="admin-home"
                      nativeExpanded={true}
                      flagsPath="./static/img/flags/"
                      country={parsePhoneNumber(admin.homePhone).country || 'US'}
                      value={admin.homePhone}
                      onChange={(e) => {this.handleInput(e, 'homePhone')}}
                    />
                  </li>
                  <li>
                    <label className="lbl-optional" htmlFor="admin-mobile">{translation.mobile_phone.label}</label>
                    <Phone
                      id="admin-mobile"
                      nativeExpanded={true}
                      flagsPath="./static/img/flags/"
                      country={parsePhoneNumber(admin.mobilePhone).country || 'US'}
                      value={admin.mobilePhone}
                      onChange={(e) => {this.handleInput(e, 'mobilePhone')}}
                    />
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="admin-timezone">{translation.time_zone.label}</label>
                    <label className="select" htmlFor="admin-timezone">
                      <select
                        id="admin-timezone"
                        ref={(input) => { this.timeZoneSid = input }}
                        defaultValue={admin.timeZoneSid}
                        required
                        aria-required="true"
                        onChange={(e) => {this.handleInput(e, 'timeZoneSid')}}
                      >
                        <option value="">{translation.time_zone.helper}</option>
                        {SessionStore.timezoneList.map(
                          (key, i) =>
                          <option key={i} value={key.sid}>{key.name}</option>
                        )}
                      </select>
                    </label>
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="admin-currency">{translation.currency.label}</label>
                    <label className="select" htmlFor="admin-currency">
                      <select
                        id="admin-currency"
                        ref={(input) => {this.currency = input}}
                        defaultValue={admin.currencyCode}
                        required
                        aria-required="true"
                        onChange={(e) => {this.handleInput(e, 'currencyCode')}}
                      >
                        <option value="">{translation.currency.helper}</option>
                        {SessionStore.currencyList.map(
                          (key, i) =>
                          <option key={i} value={key.code}>{key.name}</option>
                        )}
                      </select>
                    </label>
                  </li>
                </ul>
              </fieldset>

              <div className="panel__actions actions">
                {userSid &&
                  <button
                    className="actions__btn actions__btn--primary"
                  >
                    {translation.edit_button}
                  </button>
                }

                {!userSid &&
                  <button
                    className="actions__btn actions__btn--primary"
                  >
                    {translation.add_button}
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('EditAdmin')(EditAdmin);


// WEBPACK FOOTER //
// ./src/app/components/Admins/EditAdmin.js